import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React, { FC } from 'react';

export const PartnerStageIcon: FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V4.5H2V3Z" />
    <path d="M3 14C2.44772 14 2 13.5523 2 13V6H14V13C14 13.5523 13.5523 14 13 14H9C8.86193 14 8.75 13.8881 8.75 13.75V11.25C8.75 11.1119 8.86193 11 9 11H10.4898C10.7212 11 10.8371 10.7107 10.6734 10.5415L8.36734 8.15726C8.16448 7.94752 7.83557 7.94752 7.63271 8.15726L5.32662 10.5415C5.163 10.7107 5.27888 11 5.51028 11H7C7.13807 11 7.25 11.1119 7.25 11.25V13.75C7.25 13.8881 7.13807 14 7 14H3Z" />
  </SvgIcon>
);
